"use client";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <div>
      <h2>Something went wrong!</h2>
      <p>
        This error page is WIP. <br />
        {error.name} message (must be hidden in production):
      </p>
      <pre>{error.message}</pre>
    </div>
  );
}
